import { Component, input } from '@angular/core';
import { TemplateSlot, Tooltip } from '../../interfaces';
import { FetchVisualPipe, TranslationKeyPipe } from '../../pipes';
import { CommonModule } from '@angular/common';
import { VisualType } from '../../enums';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VisualIdPipe } from '../../pipes/visual-id.pipe';

@Component({
    selector: 'ca-visual',
    templateUrl: './visual.component.html',
    styleUrls: ['./visual.component.scss'],
    imports: [CommonModule, MatTooltipModule, FetchVisualPipe, VisualIdPipe, TranslationKeyPipe]
})
export class VisualComponent {
    slot = input<TemplateSlot>();
    value = input<string | number>('');
    tooltip = input<Tooltip>();
    iconSize = input<number | null>(null);
    tooltipIconSize = input<number>(24);

    readonly visualType = VisualType;
    readonly sourcePlaceholder = '/assets/ca-images/visual-placeholder.svg';
}
